import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

import { AddToChronologyDialog } from '../../../../facts/components/dialogs/add-to-chronology-dialog';
import useAddFactsToChronology from '@/api/mutations/useAddFactsToChronology';
import { useGetChronologies } from '@/api/queries/useGetChronologies';

interface SelectChronologyModalProps {
  isOpen: boolean;
  handleClose: () => void;
  factIds: string[];
}

export function SelectChronologyModal({ isOpen, handleClose, factIds }: SelectChronologyModalProps) {
  const { subsetId } = useParams();
  if (!subsetId) return null;

  const { data: chronologiesResponse, isLoading: isLoadingChronologies } = useGetChronologies({
    caseId: subsetId,
    paginated: false,
  });
  const { mutate: addFactsMutation, isLoading: isAddingFacts } = useAddFactsToChronology();

  const handleSelectChronology = (chronologyId: string) => {
    addFactsMutation(
      {
        caseId: subsetId,
        chronologyId,
        factIds,
      },
      {
        onSuccess: (data) => {
          const addedCount = data?.addedFacts?.length ?? 0;
          const duplicateCount = factIds.length - addedCount;

          if (addedCount === 0) {
            toast.info('All facts already exist in this chronology');
          } else {
            toast.success(
              `${addedCount} ${addedCount === 1 ? 'fact' : 'facts'} added to chronology ${duplicateCount ? `(${duplicateCount} already ${duplicateCount === 1 ? 'exists' : 'exist'})` : ''}`,
            );
          }
          handleClose();
        },
        onError: () => {
          toast.error('Failed to add facts to chronology');
        },
      },
    );
  };

  return (
    <AddToChronologyDialog
      isOpen={isOpen}
      onOpenChange={handleClose}
      isLoadingChronologies={isLoadingChronologies}
      chronologies={chronologiesResponse?.chronologies ?? []}
      handleSelectChronology={handleSelectChronology}
      isAddingFacts={isAddingFacts}
    />
  );
}
